import { render } from "./OtherProjectInput.vue?vue&type=template&id=7ffaca46&scoped=true"
import script from "./OtherProjectInput.vue?vue&type=script&lang=js"
export * from "./OtherProjectInput.vue?vue&type=script&lang=js"

import "./OtherProjectInput.vue?vue&type=style&index=0&id=7ffaca46&scoped=true&lang=css"

import exportComponent from "/Users/tamotsu/Documents/たもつ製作所/jibi/jibi-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ffaca46"]])

export default __exports__